export { default as QaqcIndexView } from "@/views/QAQC/index.vue";
export { default as QaqcOverviewView } from "@/views/QAQC/Overview.vue";
export { default as QaqcDetailView } from "@/views/QAQC/DetailView.vue";
export const UnifiedTestView = () =>
  import("@/components/layout/QAQC/UnifiedTestView.vue");
